// extracted by mini-css-extract-plugin
export default {"bg":"aoJR9m","inlineContent":"VwST0m","pageWrapper":"yXzUdR","shd":"K3Lsk9","left":"XDrMYT","right":"DiRjfU","innerBg":"NSk7ga"};